module.exports = __webpack_public_path__ + "static/icons/icon-mis-seguros-proyeccion3.7c706e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-mis-seguros-proyeccion3.gif
// module id = qQud
// module chunks = 1